import routes from './routes'
import router from '.'
import { auth } from '@/firebase'
import { User } from 'firebase'

const waitForAuth = ():Promise<User | null> => {
  return new Promise((resolve, reject) => {
    try {
      auth.onAuthStateChanged(resolve)
    } catch (err) {
      reject(err)
    }
  })
}

export default async (to, from, next) => {
  const user = await waitForAuth()
  const authenticated = !!user

  let route = null as any
  let error = null as any
  let permitted = false
  
  try {
    if (!to.matched.length) {
      error = {
        message: "Invalid route selected.",
        status: 404
      }
      return navigate(error, authenticated, permitted)
    }

    const tmatched = to.matched[to.matched.length -1]

    route = routes.find(route => {
      const rpath = route.path
      return rpath == tmatched.path
    })
  } catch (err) {
    window.console.log(err)
    error = {
      message: "Unexpected error while navigating.",
      status: 500
    }
    return navigate(error, authenticated, permitted)
  }

  if (route !== undefined) {

    const scope = localStorage.getItem('idTokenScope') || ""
    
    permitted = !route.requireAuth || route.permissions.every(permission => {
      return scope.indexOf(permission) > -1 || scope.indexOf(`${permission.split(":")[0]}:super`) > -1
    })

  } else {
    error = {
      message: "Page not found or not available.",
      status: 404
    }
    return navigate(error, authenticated, permitted)
  }

  return navigate(error, authenticated, permitted)

  function navigate(_error, _authenticated?, _permitted?) {
    if (_error) {
      alert(_error.message)
      if (_error.status === 404) {
        return router.push({name: "404", params: {path: to.path, fullPath: to.fullPath}})
      } else if (_authenticated) {
        return router.push(from)
      } else {
        return router.push("/auth")
      }
    } else {
      if (_permitted) {
        return next()
      } else if (_authenticated) {
        alert("Access denied. Please, contact your administrator if you think this is an error.")
        return router.push(from)
      } else {
        return router.push({ name: "auth", params: { redirect: to.fullPath } })
      }
    }
  }

}
